import React from "react";
import "./Criticalthinking.css";

const Criticalthinking = () => {
  return (
    <div className="container scrollable-content">
      <h3>Working with Words</h3>
      <p className='question'>A. Find the words from the text that match with the following meanings.</p>

      <div className="word-meaning">
        <h4>a. shuffling</h4>
        <p>Walking by dragging one's feet along or without lifting them fully from the ground.</p>
      </div>
      <div className="word-meaning">
        <h4>b. doodling</h4>
        <p>Drawing pictures or patterns while thinking about something else.</p>
      </div>
      <div className="word-meaning">
        <h4>c. plaque</h4>
        <p>A piece of flat metal with writing on it.</p>
      </div>
      <div className="word-meaning">
        <h4>d. precept</h4>
        <p>A general rule intended to regulate behaviour or thought.</p>
      </div>
      <div className="word-meaning">
        <h4>e. sneak</h4>
        <p>Move or go in a furtive or stealthy way.</p>
      </div>

      <hr />

      <p className='question'>B. Consult your teacher and define the following thinking skills.</p>
      <div className="word-meaning">
        <h4>a. Convergent Thinking</h4>
        <p>Focusing on finding the single best or correct answer to a clearly defined problem.</p>
      </div>
      <div className="word-meaning">
        <h4>b. Divergent Thinking</h4>
        <p>The ability to generate many different ideas or solutions for a problem.</p>
      </div>
      <div className="word-meaning">
        <h4>c. Critical Thinking</h4>
        <p>
          The ability to analyze information clearly and rationally, question assumptions, evaluate evidence,
          and make logical decisions.
        </p>
      </div>
      <div className="word-meaning">
        <h4>d. Creative Thinking</h4>
        <p>
          The ability to think in new and original ways. It involves generating fresh ideas, solving problems imaginatively,
          and looking at situations from unique perspectives.
        </p>
      </div>

      <hr />
      <h3>Comprehension</h3>
      <p className='question'>Answer the following questions.</p>

      <div className="qa">
        <p className='question'><strong>a.</strong> Who was Jack? How did he make children laugh?</p>
        <p>Jack was a classmate of the narrator. He was the kind of kid other children liked and had many friends. He made children laugh by telling jokes, cracking riddles, and joking around with kids even those who weren't in his own homeroom.</p>
      </div>

      <div className="qa">
        <p className='question'><strong>b.</strong> Why are "Sharks" important to Reid?</p>
        <p>Sharks are important to Reid because they help keep the ocean clean by eating dead organisms. This act plays a vital role in maintaining a healthy marine environment.</p>
      </div>

      <div className="qa">
        <p className='question'><strong>c.</strong> What does Mr. Browne think about the most important thing?</p>
        <p>Mr. Browne thinks that the most important thing is to know oneself. According to him, understanding and evaluating our own character helps us grow and become the best version of ourselves.</p>
      </div>

      <div className="qa">
        <p className='question'><strong>d.</strong> What is it that has not been noticed by the student?</p>
        <p>The plaque next to the door of the school, which says “Know Thyself,” is the thing that has not been noticed by the students.</p>
      </div>

      <div className="qa">
        <p className='question'><strong>e.</strong> How did Jack make fun of the English class?</p>
        <p>Jack made fun of the English class by humorously answering Mr. Browne's question, “Why are you here?” He jokingly said that they were there to attend English class and started talking about all the fun things they would be doing that year, making the class laugh.</p>
      </div>

      <div className="qa">
        <p className='question'><strong>f.</strong> What were the students going to do at the end of the month?</p>
        <p>At the end of the month, the students were going to write an essay based on Mr. Browne's precept.</p>
      </div>

      <div className="qa">
        <p className='question'><strong>g.</strong> What particular act of students surprised a girl student?</p>
        <p>The girl student was surprised by the act of students writing their own personal precepts on a postcard and mailing them to Mr. Browne during the summer vacation after graduation.</p>
      </div>

      <hr />
      <h3>Critical Thinking</h3>
      <div className="qa">
        <p className='question'><>a.</> Have you made your own precept after you read this lesson? What is it? Share it with your friends.</p>
        <p>
          Yes, after reading this lesson, I have created my own precept. A precept is a rule or principle that guides our behavior and thoughts.<br />
          <p>My Precept:</p><br />
          "When given a choice between being right or being kind, I choose kindness."<br />
          I believe kindness is more important than always proving we are right. Being kind helps build good relationships and makes the world a better place. Sometimes, winning an argument is less valuable than showing compassion and understanding toward others.
        </p>
      </div>
         <hr/>
      <div className="qa">
        <p className='question'><>b.</> According to Josh Lanyon, "If there was one life skill everyone on the planet needed, it was the ability to think with critical objectivity." Justify this statement with your logic.</p>
        <p>
          Josh Lanyon said, “If there was one life skill everyone on the planet needed, it was the ability to think with critical objectivity.” This means that the most important skill for all people is the ability to think clearly, logically, and without bias.<br /><br />
          Critical objectivity refers to the ability to analyze situations and information carefully, separating facts from emotions or assumptions, and making fair, reasoned judgments. It is closely connected to critical thinking skills such as analysis, interpretation, inference, explanation, and open-mindedness.<br /><br />
          Throughout history, human progress and development have depended on people's ability to think critically and objectively. Whether inventing new tools, solving problems, or making decisions, success comes when people can evaluate situations without letting personal feelings or biases cloud their judgment.<br /><br />
          Life skills such as problem-solving, decision-making, and creativity depend on this ability to think critically. For example, creative thinking requires not only new ideas but also the ability to assess those ideas objectively and choose the best solutions.<br /><br />
          Without critical objectivity, people may act on incorrect assumptions, biases, or misinformation, leading to poor decisions. On the other hand, thinking objectively allows us to learn from experience, improve ourselves, and make better choices in life.<br /><br />
          Therefore, Josh Lanyon's statement is justified because critical objectivity is the foundation of all other life skills. It enables us to face challenges wisely, adapt to changes, and contribute positively to our world.
        </p>
      </div>

      <hr />
      <h3>Writing</h3>
      <div className="qa">
        <p className='question'>Write an email to your friend explaining an interesting class you had.</p>
        <p>
          From: your.email@example.com<br />
          To: friend.email@example.com<br />
          Cc: anotherfriend@example.com<br />
          Bcc: hiddenfriend@example.com<br />
          Subject: An Interesting Class Experience to Share!<br /><br />

          Hi [Friend's Name],<br /><br />

          I hope you are doing well! I was really happy to receive your email this morning and to hear about your achievements. It feels great to stay connected even when we are busy.<br /><br />

          I wanted to share an interesting experience I had recently in one of my classes. The day before yesterday, our girls' group decided to join a language class at a nearby institute. When we arrived, we waited in the classroom for about half an hour before the teacher came in.<br /><br />

          He was a tall, friendly man who greeted us warmly, as if we were old friends. He introduced himself and even asked for our names. What impressed me the most was his excellent English accent and fluent speaking style—it felt like we were listening to a native speaker! He used jokes and funny gestures to make the class lively and enjoyable.<br /><br />

          In just half an hour, he taught us the general way to introduce ourselves in English. The environment was so friendly and encouraging that we all felt confident and eager to learn more. By the end of the class, we had already decided to enroll in a three-month basic course with him.<br /><br />

          This class was not only fun but also very helpful, and I'm excited about improving my English skills.<br /><br />

          How about you? Have you had any interesting classes recently? Write back when you get a chance!<br /><br />

          Take care and stay safe,<br />
          [Your Name]
        </p>
      </div>

      <hr />
      <h3>Grammar</h3>
      <p className='question'>Rewrite the following sentences adding appropriate question tags.</p>
     
        <p>Gill does not know Ann, <strong>does he?</strong></p>
        <p>I'm very patient, <strong>aren't I?</strong></p>
        <p>They'd never met me before, <strong>had they?</strong></p>
        <p>Listen carefully, <strong>will you?</strong></p>
        <p>Let's have a break, <strong>shall we?</strong></p>
        <p>Let us invite them, <strong>will you?</strong></p>
        <p>Hari used to live in France as a boy, <strong>didn't he?</strong></p>
        <p>You'd better not take a hard drink, <strong>had you?</strong></p>
        <p>Sheep eat grass, <strong>don't they?</strong></p>
        <p>Mr. Pande can speak nine languages, <strong>can't he?</strong></p>
        <p>She's finished her classes, <strong>hasn't she?</strong></p>
        <p>She barely managed to reach the goal, <strong>did she?</strong></p>
        <p>Don't let him swim in the pond, <strong>will you?</strong></p>
        <p>There are lots of people here, <strong>aren't there?</strong></p>
     

      <hr />
      <p className='question'>Read the following situation. What do you say in these situations? Use question tags.</p>
      
        <p>It's going to rain soon, <strong>isn't it?</strong></p>
        <p>Shyam, you have to lend me 100 rupees, <strong>haven't you?</strong></p>
        <p>We can talk, <strong>can't we?</strong></p>
        <p>The film was very enjoyable, <strong>wasn't it?</strong></p>
        <p>He gave an excellent act, <strong>didn't he?</strong></p>
        <p>Your father hasn't arrived from the US, <strong>has he?</strong></p>
        <p>Susan will go to her new job tomorrow, <strong>won't she?</strong></p>
        <p>You have got too short hair, <strong>haven't you?</strong></p>
        <p>Let's go on a picnic, <strong>shall we?</strong></p>
        <p>Let me go for an evening walk, <strong>will you?</strong></p>
      
    </div>
  );
};

export default Criticalthinking;
